import React, { useState, useRef } from 'react';

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isHeaderHovered, setIsHeaderHovered] = useState(false);

    const menuRef = useRef(null);
    const buttonRef = useRef(null);

    const handleOutsideClick = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
            setIsMenuOpen(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    return (
        <header
            onMouseEnter={() => setIsHeaderHovered(true)}
            onMouseLeave={() => setIsHeaderHovered(false)}
            className={`pt-4 pb-3 absolute top-0 w-full z-10 flex justify-between items-center md:px-14 px-4`}
            style={{ background: 'linear-gradient(rgba(229, 222, 219, 1), rgba(229, 222, 219, 0.9), rgba(229, 222, 219, 0.8), rgba(229, 222, 219, 0.7), rgba(229, 222, 219, 0.6), rgba(229, 222, 219, 0.1))' }}>

            <a href="/">
                <img src="/images/logo.png" alt="Schedio Logo" className="md:h-12 h-8 pb-2" />
            </a>

            <div className="md:hidden" ref={buttonRef}>
                <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-2xl">&#9776;</button>
                <div ref={menuRef} className={`${isMenuOpen ? 'block' : 'hidden'} transition duration-300 absolute right-0 mt-2 py-2 w-48 bg-white rounded shadow-xl`}>
                    <a href="/portfolio" className="block px-4 py-2 text-lg text-gray-800 hover:bg-[#f5f3f1]">Portfolio</a>
                    <a href="/about" className="block px-4 py-2 text-lg text-gray-800 hover:bg-[#f5f3f1]">About</a>
                    <a href="/people" className="block px-4 py-2 text-lg text-gray-800 hover:bg-[#f5f3f1]">People</a>
                    <a href="/contact" className="block px-4 py-2 text-lg text-gray-800 hover:bg-[#f5f3f1]">Contact</a>
                </div>
            </div>

            <nav className="hidden md:block md:space-x-4 space-y-2 md:space-y-0">
                <a href="/portfolio" className="mx-2 text-2xl">Portfolio</a>
                <a href="/about" className="mx-2 text-2xl">About</a>
                <a href="/people" className="mx-2 text-2xl">People</a>
                <a href="/contact" className="mx-2 text-2xl">Contact</a>
            </nav>
        </header>

    );
}
